import React, {useEffect, useState} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import {Card, Spinner} from "reactstrap";
import {VsiBubble, VsiH4, VsiH5,} from "../../../../styled/App.styled";
import {useVsiAppContext} from "../../../../stores/VsiApp";
import {hostSummaryDefs} from "../../../../utils/gridColumnDefs/virtual/allUnits";
import Grid from "../../../../components/Grid";
import Stockchart from "../../../../components/Stockchart";
import {formatStockChartConfig, forecastWithRate} from "../../../../utils/Helpers";
import {useDataWithRoute, useTitleFromComponent} from "../../../../utils/hooks";
import {utilizationColors} from "../../../../utils/chartUtils";
import ProgressBar from "../../../../components/ProgressBar";
import dayjs from "dayjs";
import AtAGlance from "../../../../components/AtAGlance";

const chartHeight = 450;

export default function VirtualHostSummary({context, title}) {
    const [searchParams] = useSearchParams();
    const { theme, client, periodId } = useVsiAppContext();

    let navigate = useNavigate();

    const [aagData, setAagData] = useState({});
    const [utilChart, setUtilChart] = useState([]);
    const [vmGrid, setVmGrid] = useState([]);

    useTitleFromComponent(`Virtual / ${context} / ${title} - ${encodeURI(searchParams.get('esx_host_name')) || 'N/A'}`);
    const [data, {isLoading}] = useDataWithRoute(`/api/v6/report/virtual_esx_host_overview_proc?client_id=${client.clientId}&period_id=${periodId}&vcenter_name=${encodeURI(searchParams.get('vcenter_name'))}&esx_host_name=${encodeURI(searchParams.get('esx_host_name'))}&cluster_name=${encodeURI(searchParams.get('cluster_name'))}`)

    const formatGraphData = function (dataGrid) {
        let sortedData = dataGrid.sort((a, b) => new Date(a.collection_date) - new Date(b.collection_date));
        let chartInfo = (formatStockChartConfig(sortedData, [
            {
                name: 'CPU',
                field: 'cpu_util_pct'
            },
            {
                name: 'Memory',
                field: 'memory_util_pct'
            },
            {
                name: 'Disk',
                field: 'disk_util_pct'
            }
        ]));

        return {
            utilization: chartInfo.series,
        };
    };
    const atAGlanceConfig = [
        {
            field: "cluster_name",
        },
        {
            field: "model",
        },
        {
            field: "cpu_model",
        },
        {
            field: "host_limiting_factor",
        },
        {
            field: "vm_build_capacity",
        },
        {
            field: "total_vms",
        },
        {
            field: "total_cpus"
        },
        {
            field: "avg_ghz_per_cpu"
        },
        {
            field: "total_mhz"
        },
        {
            field: "total_memory"
        },
        {
            field: "total_disk_allocated"
        }
    ];
    useEffect(() => {
        const records = data?.recordsets || [];
        setAagData(records?.[0]?.[0] || {})
        setVmGrid(records?.[1] || []);

        const chartData = records?.[3] || [];
        const dataWithForecast = forecastWithRate(chartData, ['cpu_util_pct', 'memory_util_pct', 'disk_util_pct']);
        const charts = formatGraphData(dataWithForecast);
        // const categories = [...new Set(dataWithForecast.map(chart => dayjs(chart.collection_date.replace('T', '').replace('Z', '')).format('MM/DD/YY')))];
        const lastDate = dayjs(chartData?.[chartData.length - 1]?.collection_date.replace('T', '').replace('Z', ''));
        const series = charts.utilization.map(ser => {
            return {
                ...ser,

                zoneAxis: 'x',
                zones: [
                    {
                        value: lastDate,
                    },
                    {
                        dashStyle: "Dash",
                    },]
            }
        });
        setUtilChart(series);
        // setTrendCategories(categories);

    }, [data]);

    const onRowClick = (e) => {
        navigate(`/reports/virtual/vm/vm-summary?vm_name=${encodeURI(e.data.vm_name)}&vcenter_name=${encodeURI(e.data.vcenter_name)}&cluster_name=${encodeURI(e.data.cluster_name)}&esx_host_name=${encodeURI(e.data.esx_host_name)}&period_id=${periodId}`)
    }

    return (
        <Card className={`report-card p-2 nav-card-${theme}`}>
            <VsiH4>ESX Host Summary - {decodeURI(searchParams.get('esx_host_name')) || 'N/A'}</VsiH4>

            {isLoading ? <Spinner color={"primary"}/> : (
                <div>
                    <VsiBubble autobotName="AtAGlance" autobotInfo={{config: atAGlanceConfig, data: aagData}}>
                        <VsiH5>Configuration Summary</VsiH5>
                        <AtAGlance config={atAGlanceConfig} data={aagData} size={"lg"}/>
                    </VsiBubble>
                    <VsiBubble autobotName='UtilizationProgressBars' autobotInfo={{
                        data: aagData, config: [
                            {
                                type: "single",
                                fields: ["cpu_util_pct"],
                                thresholds: [
                                    [80, "#008080"]
                                ],
                                denominator: 100,
                                title: 'CPU %'
                            }, {
                                type: "single",
                                fields: ["memory_util_pct"],
                                thresholds: [
                                    [80, "#008080"]
                                ],
                                denominator: 100,
                                title: 'Memory %'
                            }, {
                                type: "single",
                                fields: ["disk_util_pct"],
                                thresholds: [
                                    [80, "#008080"]
                                ],
                                denominator: 100,
                                title: 'Disk %'
                            }
                        ]
                    }}>
                        <div className={"d-flex"}>
                            <VsiH5 className={"pe-5"}>Utilization</VsiH5>
                            <ProgressBar data={[aagData?.cpu_util_pct || 0]}
                                         denominator={100}
                                         title={'CPU %'}
                                // titleFootnote={`${aagData?.cpu_util_pct || 0} %`}
                                         colors={[]}
                                // disableStat
                                         thresholds={[
                                             [80, "#008080"],
                                         ]}
                                         size={"sm"}/>
                            <ProgressBar data={[aagData?.memory_util_pct || 0]}
                                         denominator={100}
                                // disableStat
                                         title={'Memory %'}
                                // titleFootnote={`${aagData?.memory_util_pct || 0} %`}
                                         colors={[]}
                                         thresholds={[
                                             [80, "#008080"],
                                         ]}
                                         size={"sm"}/>
                            <ProgressBar data={[aagData?.disk_util_pct || 0]}
                                         denominator={100}
                                         title={'Disk %'}
                                // titleFootnote={`${aagData?.disk_util_pct || 0} %`}
                                // disableStat
                                         colors={[]}
                                         thresholds={[
                                             [80, "#008080"],
                                         ]}
                                         size={"sm"}/>

                        </div>
                    </VsiBubble>
                    <VsiBubble>
                        <Stockchart height={chartHeight}
                                    series={utilChart}
                                    config={{
                                        colors: utilizationColors
                                    }}/>
                    </VsiBubble>

                    <VsiH4>
                        Virtual Machines
                    </VsiH4>
                    <VsiBubble>
                        <Grid data={vmGrid} columnDefs={hostSummaryDefs}
                              gridText={`Double click to see detailed VM reports`}
                              rowDoubleClicked={onRowClick}/>
                    </VsiBubble>
                </div>
            )}
        </Card>
    );
}
